import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wrench } from "lucide-react";
import api from "../lib/api";

export default function MaintenanceQuickToggle() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const load = () => api.get("/maintenance/status").then((r) => setSt(r.data)).catch(() => {});
    load();
    window.addEventListener("mql:maintenance-refresh", load);
    return () => window.removeEventListener("mql:maintenance-refresh", load);
  }, []);
  if (!st) return null;
  const toggle = async () => {
    const msg = st.enabled ? "Matikan maintenance dan buka situs untuk pembeli & supplier?" : "Aktifkan maintenance sekarang? Pembeli & supplier tidak bisa membuka situs. Backup otomatis dibuat dulu.";
    if (!window.confirm(msg)) return;
    setBusy(true);
    try {
      const r = await api.put("/admin/maintenance", { enabled: !st.enabled, message: "" });
      toast.success(r.data.enabled ? "Maintenance aktif, backup tersimpan" : "Maintenance dimatikan, situs dibuka kembali");
      window.dispatchEvent(new Event("mql:maintenance-refresh"));
    } catch (err) { toast.error(err?.response?.data?.detail || "Gagal mengubah maintenance"); } finally { setBusy(false); }
  };
  return (
    <button data-testid="header-maintenance-toggle" onClick={toggle} disabled={busy} title="Mode Maintenance"
      className={`flex items-center gap-1.5 whitespace-nowrap text-xs font-bold rounded-full px-3 py-1.5 border transition-colors disabled:opacity-50 ${st.enabled ? "bg-[#F06464] border-[#F06464] text-white hover:bg-[#ff7b7b]" : "border-[#35353B] text-[#A8A8AD] hover:border-[#D4AF37] hover:text-[#D4AF37]"}`}>
      <Wrench size={13} /> <span data-testid="header-maintenance-state" className="hidden sm:inline">{busy ? "..." : st.enabled ? "MAINT ON" : "MAINT OFF"}</span>
    </button>
  );
}
